module.exports = __webpack_public_path__ + "media/svg/me-cd3656ad.svg";